// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6b1ad7bc","453":"ce73c980"}[chunkId] + ".chunk.js";
};